(function ($, global) {


    /**
     * Klikání
     * */
    var firstClickDateString = "";
    function handleHighlightingDays (event) {
        var type = event.type;
        var $day = $(this);
        var $calendarsWrapper = $day.closest(".js-calendars");
        var $days = $calendarsWrapper.find(".js-day");
        $days.removeClass("calendar-item--highlighted calendar-item--handlerFrom calendar-item--handlerTo");

        $calendarsWrapper.find(".js-day:not(.calendar-item--handler) .fshr-calendar-tooltip").remove();
        var $handler = $calendarsWrapper.find(".js-day.calendar-item--handler");
        var $handlerTooltip = $handler.find(".fshr-calendar-tooltip");
        var $handlerTooltipText = $handlerTooltip.find(".fshr-tooltip-box");

        var handlerTooltipDefaultText = $handlerTooltipText.text();
        var handlerTooltipText = global.localization.calendarTooltips.from;
        var selectTooltipText = global.localization.calendarTooltips.toSelect;
        $day.addClass("calendar-item--handlerTo");
        $handler.addClass("calendar-item--handlerFrom");

        if (type == "mouseenter") {
            var $inputs = getDateInputElements($calendarsWrapper);
            var highlightFrom = $inputs.dateFromElement.val() || $day.attr("data-date");
            var highlightTo = $inputs.dateToElement.val() || $day.attr("data-date");

            var dates = getDateFromAndDateTo(highlightFrom, highlightTo);
            $days.filter(function() {
                var timestamp = createDateObjectFromString($(this).attr("data-date")).getTime();
                var returnValue = false;
                if (dates.dateFrom.timestamp <= timestamp && timestamp <= dates.dateTo.timestamp) {
                    returnValue = true;
                }
                return returnValue
            }).addClass("calendar-item--highlighted");


            if (dates.fixedDate.name == "dateFrom") {
                handlerTooltipText = global.localization.calendarTooltips.to;
                selectTooltipText = global.localization.calendarTooltips.fromSelect;
                $day.removeClass("calendar-item--handlerTo").addClass("calendar-item--handlerFrom");
                $handler.removeClass("calendar-item--handlerFrom").addClass("calendar-item--handlerTo");
            }
            appendTooltip(selectTooltipText, $day);
        }

        if ($handlerTooltip.length && handlerTooltipDefaultText != handlerTooltipText) {
            $handlerTooltip.remove();
            appendTooltip(handlerTooltipText, $handler);
        }
    }
    function disableFirstClick ($calendarsWrapper, $days) {
        firstClickDateString = "";
        $(document).off("mouseenter", ".js-day:not(.calendar-item--disabled, .calendar-item--handler)", handleHighlightingDays);
        $(document).off("mouseleave", ".js-day:not(.calendar-item--disabled, .calendar-item--handler)", handleHighlightingDays);
        $calendarsWrapper.removeAttr("data-firstClick");
        $days.removeClass("calendar-item--moveDisabled calendar-item--highlighted");
    }
    function handleCalendarDayClick () {
        var $day = $(this);
        var dateString = $day.attr("data-date");
        var $calendarsWrapper = $day.closest(".js-calendars");

        var $days = $calendarsWrapper.find(".js-day");

        if (firstClickDateString != dateString) {
            if (!$calendarsWrapper.attr("data-firstClick")) {
                // první kliknutí

                $days.find(".fshr-calendar-tooltip").remove();

                var $inputs = getDateInputElements($calendarsWrapper);
                $inputs.dateFromElement.val("");
                $inputs.dateToElement.val("");

                $calendarsWrapper.attr("data-firstClick", 1);
                firstClickDateString = dateString;

                $inputs.dateFromElement.val(firstClickDateString);

                $days.removeClass("calendar-item--selected calendar-item--handler calendar-item--handlerFrom calendar-item--handlerTo");
                $day.addClass("calendar-item--handler calendar-item--handlerFrom calendar-item--moveDisabled");

                //appendTooltip(global.localization.calendarTooltips.from, $day);

                if (!global.isTouchDevice) {
                    $(document).on("mouseenter", ".js-day:not(.calendar-item--disabled, .calendar-item--handler)", handleHighlightingDays);
                    $(document).on("mouseleave", ".js-day:not(.calendar-item--disabled, .calendar-item--handler)", handleHighlightingDays)
                }
            } else {
                // druhé kliknutí

                $day.addClass("calendar-item--handler");

                setDateFromAndDateTo(firstClickDateString, dateString, $day);

                disableFirstClick($calendarsWrapper, $days);
            }
        }
    }
    $(document).on("click", ".js-day:not(.calendar-item--disabled)", handleCalendarDayClick);

    /** getDateInputElements */
    function getDateInputElements ($calendarsWrapper) {
        var dateFromElementSelector = $calendarsWrapper.attr("data-from-element-selector") || $("#filter-departure-date");
        var dateToElementSelector = $calendarsWrapper.attr("data-to-element-selector") || $("#filter-return-date");

        return {
            dateFromElement: global.getElementsBySelector(dateFromElementSelector, $calendarsWrapper),
            dateToElement: global.getElementsBySelector(dateToElementSelector, $calendarsWrapper)
        }
    }

    /** getDateFromAndDateTo */
    function getDateFromAndDateTo (date1, date2) {

        var firstTime = createDateObjectFromString(date1).getTime();
        var secondTime = createDateObjectFromString(date2).getTime();

        var dateFrom = firstTime;
        var dateTo = secondTime;

        var returnValue = {
            dateFrom: {
                string: date1,
                timestamp: dateFrom
            },
            dateTo: {
                string: date2,
                timestamp: dateTo
            },
            fixedDate: {
                name: "dateTo",
                value: dateTo
            }
        };


        if (firstTime > secondTime) {
            returnValue = {
                dateFrom: {
                    string: date2,
                    timestamp: dateTo
                },
                dateTo: {
                    string: date1,
                    timestamp: dateFrom
                },
                fixedDate: {
                    name: "dateFrom",
                    value: dateFrom
                }
            };
        }

        return returnValue;
    }

    /** setDaysCountToElements */
    var selectChangeTimeout = 0;
    function setDaysCountToElements ($element, text) {
        if ($element.is("option")) {
            $element.text(text);
            clearTimeout(selectChangeTimeout);
            selectChangeTimeout = setTimeout(function () {
                $element.closest("select").trigger("select-change");
            }, 50);
        } else {
            $element.find("span").text(text);
        }
    }

    /** Výběr dní */
    function appendTooltip (text, $day) {
        var $tooltip = $("<div class='qtip-default qtip-focus qtip-pos-bc fshr-tooltip-inline fshr-calendar-tooltip'></div>");
        $tooltip.html('<div class="qtip-content fshr-tooltip-content"><div class="fshr-tooltip-box">' + text + '</div></div>');
        $("body").append($tooltip).css({
            left: "-2000px",
            top: "-2000px"
        });
        var tooltipWidth = $tooltip.outerWidth();
        $tooltip.css({
            marginLeft: - (tooltipWidth/2)
        });
        $day.children("div").append($tooltip);
    }
    function getDaysCount (date1Timestamp, date2Timestamp) {
        var millisecondsInDay = 24*60*60*1000;
        var daysCount = Math.round(Math.abs((date1Timestamp - date2Timestamp)/(millisecondsInDay))) + 1;
        return daysCount;
    }
    function setDateFromAndDateTo (date1StringToChangeIfNecessary, date2String, $element, rewriteInputValues, stopCheckDays) {
        if (typeof rewriteInputValues === 'undefined') {
            rewriteInputValues = true;
        }
        var $calendarsWrapper = $element.closest(".js-calendars");
        var attributes = getCalendarAttributes($calendarsWrapper);


        var dates = getDateFromAndDateTo(date1StringToChangeIfNecessary, date2String);


        var datesFixedOverflow = handleOverflowedDates(dates.dateFrom.string, dates.dateTo.string, attributes);

        var dateFrom = datesFixedOverflow.dateFrom;
        var dateTo = datesFixedOverflow.dateTo;

        var maximumNightRange = attributes.maximumNightRange;
        if (maximumNightRange) {

            var daysCount = getDaysCount(dateFrom.timestamp, dateTo.timestamp);
            var nightsCount = daysCount - 1;
            var nightsCountText = nightsCount + " " + global.getProperSuffix(nightsCount, global.localization.nights.join(",")) + " " + global.localization.exactly;

            if (nightsCount > maximumNightRange) {
                var dateModified = null;
                if (dates.fixedDate.name == "dateTo") {
                    dateModified = new Date(dateTo.timestamp);
                    dateModified.setDate(new Date(dateTo.timestamp).getDate() - maximumNightRange);
                    dateFrom.timestamp = dateModified;
                    dateFrom.string = createDateStringFromObject(new Date(dateModified));
                    dateFrom.timestamp = createDateObjectFromString(dateFrom.string).getTime();

                    if ($calendarsWrapper.attr("data-fixed-date")) {
                        $calendarsWrapper.attr("data-fixed-date", dateFrom.string);
                    }
                } else {
                    dateModified = new Date(dateFrom.timestamp);
                    dateModified.setDate(new Date(dateFrom.timestamp).getDate() + maximumNightRange);
                    dateTo.string = createDateStringFromObject(new Date(dateModified));
                    dateTo.timestamp = createDateObjectFromString(dateTo.string).getTime();

                    if ($calendarsWrapper.attr("data-fixed-date")) {
                        $calendarsWrapper.attr("data-fixed-date", dateTo.string);
                    }
                }
            }
        }

        var $inputs = getDateInputElements($calendarsWrapper);
        if (rewriteInputValues) {
            $inputs.dateFromElement.val(dateFrom.string);
            $inputs.dateToElement.val(dateTo.string);
            $inputs.dateFromElement.trigger("date-change");
            $inputs.dateToElement.trigger("date-change");

            var daysCountSelector = $calendarsWrapper.attr("data-exactrange-selector");
            if (daysCountSelector) {
                var $daysCount = global.getElementsBySelector(daysCountSelector, $calendarsWrapper);
                if ($daysCount.length) {
                    $daysCount.each(function () {
                        setDaysCountToElements($(this), nightsCountText)
                    });
                }
            }

            var defaultData = getDefaultData($calendarsWrapper);
            if (defaultData.from && defaultData.to) {
                if (defaultData.from != dateFrom.string || defaultData.to != dateTo.string) {
                    $calendarsWrapper.addClass("js-calendar--isModified");
                } else {
                    $calendarsWrapper.removeClass("js-calendar--isModified");
                }

                var $parent = $element.closest(".js-change-detection");
                if ($parent.length) {
                    $parent.trigger("change-detected");
                }
            }
            if (!stopCheckDays) {
                //global.daysCountRestrictions($calendarsWrapper);
            }
        }

        selectDays(dateFrom.timestamp, dateTo.timestamp, $element);

    }
    function selectDays (dateFromTimestamp, dateToTimestamp, $inCalendarElement) {
        var $calendarsWrapper = $inCalendarElement.closest(".js-calendars");

        var $days = $calendarsWrapper.find(".js-day:not(.calendar-item--disabled)");

        $days.removeClass("calendar-item--selected calendar-item--handler");
        $days.find(".fshr-calendar-tooltip").remove();

        $days.each(function () {
            var $day = $(this);
            var dayTime = createDateObjectFromString($day.attr("data-date")).getTime();
            if (dateFromTimestamp == dayTime || dayTime == dateToTimestamp) {
                $day.addClass("calendar-item--handler");
                if (dateFromTimestamp == dayTime) {
                    $day.addClass("calendar-item--handlerFrom");
                } else {
                    $day.addClass("calendar-item--handlerTo");
                }
                if (firstClickDateString) {
                    $day.addClass("calendar-item--moveDisabled");
                }
            }
            if (dateFromTimestamp < dayTime && dayTime < dateToTimestamp) {
                $day.addClass("calendar-item--selected");
            }
        });
    }


    /**
     * Přesouvání
     * */
    function dayMoveHandler (event) {
        var $day = $(this);
        var date1 = $day.attr("data-date");
        var $calendars = $day.closest(".js-calendars");
        var date2 = $calendars.attr("data-fixed-date");

        setDateFromAndDateTo(date2, date1, $day);
    }
    function createDateStringFromObject (dateObject) {
        var dateString = dateObject.getFullYear() + "-" + ("0" + (dateObject.getMonth() + 1)).substr(-2)  + "-" + ("0" + dateObject.getDate()).substr(-2);
        return dateString;
    }
    function createDateObjectFromString (dateString) {
        var dateParts = dateString.split("-");
        var year = parseInt(dateParts[0], 10);
        var month = parseInt(dateParts[1], 10) - 1;
        var day = parseInt(dateParts[2], 10);
        var dateObject = new Date(year, month, day);
        return dateObject;
    }
    global.createDateObjectFromString = createDateObjectFromString;
    global.createDateStringFromObject = createDateStringFromObject;
    /**
    * Generování
    **/

    function generateControlButton (restrictionDate, dateFromMonth, dateFromYear, buttonClasses, buttonText, addMonths, dataTestId) {

        if(typeof dataTestId == "undefined"){
            dataTestId = "";
        }

        var restrictionMonth = null;
        var restrictionYear = null;
        var buttonIsDisabled = false;

        var newCalendarFromMonth = parseInt(dateFromMonth, 10) + addMonths;

        var newCalendarFromYear = parseInt(dateFromYear, 10);

        if (newCalendarFromMonth < 1) {
            newCalendarFromMonth = 12;
            newCalendarFromYear = newCalendarFromYear - 1;
        } else if (newCalendarFromMonth > 12) {
            newCalendarFromMonth = 1;
            newCalendarFromYear = newCalendarFromYear + 1;
        }

        var newCalendarFromDate = createDateStringFromObject(new Date(newCalendarFromYear, newCalendarFromMonth - 1, 1));

        if (restrictionDate) {
            restrictionMonth = parseInt(restrictionDate.split("-")[1], 10);
            restrictionYear = parseInt(restrictionDate.split("-")[0], 10);
            buttonIsDisabled = (parseInt(dateFromMonth, 10) == restrictionMonth && parseInt(dateFromYear, 10) == restrictionYear);

            if (buttonIsDisabled) {
                buttonClasses.push("fshr-calendars-controls--disabled");
            }
        }

        return '<a data-calendarfrom="' + newCalendarFromDate + '" class="' + buttonClasses.join(" ") + '" ' + dataTestId + '>' + buttonText + '</a>';
    }
    function generateCalendar (month, year, attributes, monthHeaderHtml) {
        var daysInWeek = 7;
        var weeksInMonth = 6;
        var minimumDate = attributes.minimumDate;
        var maximumDate = attributes.maximumDate;
        var highlightedDays = attributes.highlightedDays;

        var daysName = global.localization.calendar.dayNamesMin;
        var firstDayDate = new Date(year, month - 1, 1);
        var firstDayOfMonth = firstDayDate.getDay();
        if (firstDayOfMonth == 0) {
            firstDayOfMonth = 7;
        }
        var firstDayOfMonthIndex = firstDayOfMonth - 1;

        var calendarHtml = '<div class="fshr-calendarWrapper">' + monthHeaderHtml + '<table class="calendar js-calendar">';
        var calendarHeader = '<thead><tr><th>' + daysName[1] + '</th><th>' + daysName[2] + '</th><th>' + daysName[3] + '</th><th>' + daysName[4] + '</th><th>' + daysName[5] + '</th><th>' + daysName[6] + '</th><th>' + daysName[0] + '</th></tr></thead>';
        var calendarBody = '<tbody>';

        var day = new Date(year, month - 1, 1);
        day.setDate(firstDayDate.getDate() - firstDayOfMonthIndex);

        var minimumDateTimestamp = minimumDate ? new createDateObjectFromString(minimumDate).getTime() : null;
        var maximumDateTimestamp = maximumDate ? new createDateObjectFromString(maximumDate).getTime() : null;

        for (var weekInMonthIndex = 0; weekInMonthIndex < weeksInMonth; weekInMonthIndex++) {
            calendarBody = calendarBody + '<tr>';
            for (var dayInWeekIndex = 0; dayInWeekIndex < daysInWeek; dayInWeekIndex++) {
                var dayMonth = day.getMonth() + 1;
                var currentDay = day.getDate();
                var dayTimestamp = day.getTime();

                var dateParam = createDateStringFromObject(day);

                var dayClasses = ['calendar-item', 'js-day'];
                if (dayMonth !== month || (minimumDateTimestamp && minimumDateTimestamp > dayTimestamp) || (maximumDateTimestamp && maximumDateTimestamp < dayTimestamp)) {
                    dayClasses.push("calendar-item--disabled");
                }
                if (dayInWeekIndex > 4) {
                    dayClasses.push("calendar-item--holiday");
                }
                var dayIsHighlighted = false;
                if (highlightedDays.indexOf(dateParam) > -1) {
                    dayIsHighlighted = true;
                }
                calendarBody = calendarBody + '<td class="' + dayClasses.join(" ") + '" data-date="' + dateParam + '" data-test-id="search-term-day"><div class="fshr-calendar-item-box' + (dayIsHighlighted ? " fshr-calendar-item-box--highlighted" : "") + '"><span class="fshr-calendar-item-text"><span class="fshr-calendar-item-text-value">' + currentDay + '</span></span></div></td>';

                day.setDate(currentDay + 1);
            }
            calendarBody = calendarBody + '</tr>';
        }
        calendarBody = calendarBody + "</tbody>";

        calendarHtml = calendarHtml + calendarHeader + calendarBody + "</table></div>";
        return calendarHtml;
    }
    function generateCalendars ($calendarWrapper, attributes, rewriteInputValues, stopCheckDays) {

        var calendarsCount = attributes.calendarsCount;

        var year = parseInt(attributes.dateFromYear, 10);

        var previousButtonClasses = ["fshr-calendars-controls", "fshr-calendars-controls--prev", "js-calendars-controls", "js-calendars-controls--prev", "fshr-icon", "fshr-icon--caretLeft"];
        var monthPrevButtonHtml = generateControlButton(attributes.minimumDate, attributes.dateFromMonth, attributes.dateFromYear, previousButtonClasses, "", -1, 'data-test-id="search-term-prev-month"');

        var nextButtonClasses = ["fshr-calendars-controls", "fshr-calendars-controls--next", "js-calendars-controls", "js-calendars-controls--next", "fshr-icon", "fshr-icon--caretRight"];
        var monthNextButtonHtml = generateControlButton(attributes.maximumDate, attributes.dateFromMonth, attributes.dateFromYear, nextButtonClasses, "", 1,'data-test-id="search-term-next-month"');

        var monthHeaderHtml = '';
        var calendarsHtml = '';
        var monthsInYear = 12;
        var yearIndex = 0;

        var dateFromMonth = attributes.dateFromMonth;

        for (var calendarIndex = 0; calendarIndex < calendarsCount; calendarIndex++) {
            var month = parseInt(dateFromMonth, 10) + calendarIndex;
            if (month > monthsInYear) {
                month = month - (monthsInYear * yearIndex);
            }

            if (month > 12) {
                month = 1;
                year = year + 1;
            }

            var monthIndex = month - 1;

            monthHeaderHtml = '<div class="fshr-calendars-header"><div class="fshr-calendars-title">' + monthPrevButtonHtml + '<span class="fshr-calendars-title-text">' + global.localization.calendar.monthNames[monthIndex] + ' ' + year + '</span>' + monthNextButtonHtml + '</div></div>';

            calendarsHtml = calendarsHtml + generateCalendar(month, year, attributes, monthHeaderHtml);

            if ((month % year) == 0) {
                year = parseInt(year, 10) + 1;
                yearIndex = yearIndex + 1;
            }
        };

        $calendarWrapper.html("");
        $calendarWrapper.addClass("fshr-calendars--" + calendarsCount);
        $calendarWrapper.append(calendarsHtml);

        var selectedFrom = createDateObjectFromString(attributes.selectedFrom);
        var selectedTo = createDateObjectFromString(attributes.selectedTo);

        if (rewriteInputValues) {
            var today = createDateStringFromObject(new Date());

            if (!attributes.selectedFrom) {
                selectedFrom = createDateObjectFromString(today);
                selectedFrom.setDate(selectedFrom.getDate() + 1);
            }
            if (!attributes.selectedTo) {
                selectedTo = createDateObjectFromString(today);
                selectedTo.setDate(selectedTo.getDate() + 32);
            }
        }

        var selectedFromString = createDateStringFromObject(selectedFrom);
        var selectedToString = createDateStringFromObject(selectedTo);

        setDateFromAndDateTo(selectedFromString, selectedToString, $calendarWrapper, rewriteInputValues, stopCheckDays);
    }
    function getCalendarAttributes ($item) {
        var $calendarsPlaceholder = $item.closest(".js-calendars");
        var $inputs = getDateInputElements($calendarsPlaceholder);
        var dateFrom = $item.attr("data-calendarfrom");

        var todayDate = new Date();
        //todayDate.setDate(todayDate.getDate() + 1);

        if (!dateFrom) {
            var todayMonth = todayDate.getMonth();
            var todayYear = todayDate.getFullYear();
            dateFrom = todayYear + "-" + (todayMonth + 1) + "-01";
        }

        var dateFromYear = parseInt(dateFrom.split("-")[0], 10);
        var dateFromMonth = parseInt(dateFrom.split("-")[1], 10);

        var calendarsCount = $calendarsPlaceholder.attr("data-calendarscount") || 2;

        var selectedFrom = $inputs.dateFromElement.val();
        var selectedTo = $inputs.dateToElement.val();

        var minimumDate = $calendarsPlaceholder.attr("data-minimumdate") || createDateStringFromObject(todayDate);
        var maximumDate = $calendarsPlaceholder.attr("data-maximumdate") || createDateStringFromObject(new Date(todayDate.getFullYear() + 1, 11, 31));

        var maximumNightRange = $calendarsPlaceholder.attr("data-datepicker-range-min") || 61;
        var defaultNightRange = $calendarsPlaceholder.attr("data-datepicker-defaultrange") || 8;

        var highlightedDays = [];
        var highlightedDaysVariableName = $calendarsPlaceholder.attr("data-datepicker-highdays-variable") || "dostupneTerminy";
        var highlightedDaysVariable = window[highlightedDaysVariableName];
        if (highlightedDaysVariable) {
            var highlightedDaysSeasonName = $calendarsPlaceholder.attr("data-datepicker-highdays-season") || "winter";
            var highlightedDaysSeason = highlightedDaysVariable[highlightedDaysSeasonName];
            if (highlightedDaysSeason) {
                var highlightedDaysLengthName = $calendarsPlaceholder.attr("data-datepicker-highdays-length");
                if (highlightedDaysLengthName) {
                    var lengths = highlightedDaysLengthName.split("|");
                    $.each(lengths, function (index, lengthName) {
                        var newHighlightedDays = highlightedDaysSeason[lengthName];
                        if (newHighlightedDays) {
                            highlightedDays = highlightedDays.concat(newHighlightedDays);
                        }
                    });
                }
            }
        };

        return {
            dateFromMonth: dateFromMonth,
            dateFromYear: dateFromYear,
            calendarsCount: calendarsCount,
            selectedFrom: selectedFrom,
            selectedTo: selectedTo,
            minimumDate: minimumDate,
            maximumDate: maximumDate,
            maximumNightRange: parseInt(maximumNightRange, 10),
            defaultNightRange: parseInt(defaultNightRange, 10),
            highlightedDays: highlightedDays
        }
    }
    function setDefaultData ($calendar) {
        var $inputs = getDateInputElements($calendar);
        if (!$calendar.attr("data-calendar-select-defaultfrom") && $inputs.dateFromElement.val()) {
            $calendar.attr("data-calendar-select-defaultfrom", $inputs.dateFromElement.val());
        }
        if (!$calendar.attr("data-calendar-select-defaultto") && $inputs.dateToElement.val()) {
            $calendar.attr("data-calendar-select-defaultto", $inputs.dateToElement.val());
        }
    }

    function getDefaultData ($calendar) {
        return {
            from: $calendar.attr("data-calendar-select-defaultfrom"),
            to: $calendar.attr("data-calendar-select-defaultto")
        }
    }

    function createCalendars ($calendarsPlaceholder) {
        var calendarAttributes = getCalendarAttributes($calendarsPlaceholder);

        generateCalendars($calendarsPlaceholder, calendarAttributes, true);
        setDefaultData($calendarsPlaceholder);
    }

    function handleOverflowedDates (dateFrom, dateTo, attributes) {

        var minimumDateObject = createDateObjectFromString(attributes.minimumDate);
        var minimumDateTimestamp = minimumDateObject.getTime();
        var maximumDateObject = createDateObjectFromString(attributes.maximumDate);
        var maximumDateTimestamp = maximumDateObject.getTime();

        var dateFromTimestamp = createDateObjectFromString(dateFrom).getTime();
        var dateToTimestamp = createDateObjectFromString(dateTo).getTime();

        var dateFromChanged = false;
        var dateIsOutOfRange = false;

        if (dateFromTimestamp < minimumDateTimestamp) {
            dateFrom = minimumDateObject;
            dateFromChanged = true;
        }
        if (dateFromTimestamp >= maximumDateTimestamp) {
            dateFrom = new Date(maximumDateTimestamp);
            dateFrom.setDate(dateFrom.getDate() - 1);
            dateFromChanged = true;
            dateIsOutOfRange = true;
        }
        var dateToChanged = false;
        if (dateToTimestamp > maximumDateTimestamp) {
            dateTo = maximumDateObject;
            dateToChanged = true;
        }
        if (dateToTimestamp <= minimumDateTimestamp) {
            dateTo = new Date(minimumDateTimestamp);
            dateTo.setDate(dateTo.getDate() + 1);
            dateToChanged = true;
            dateIsOutOfRange= true;
        }

        if (dateFromChanged) {
            dateFrom = createDateStringFromObject(dateFrom);
            dateFromTimestamp = createDateObjectFromString(dateFrom).getTime();
        }
        if (dateToChanged) {
            dateTo = createDateStringFromObject(dateTo);
            dateToTimestamp = createDateObjectFromString(dateTo).getTime();
        }

        var returnValue = {
            dateFrom: {
                string: dateFrom,
                timestamp: dateFromTimestamp
            },
            dateTo: {
                string: dateTo,
                timestamp: dateToTimestamp
            },
            isOutOfRange: dateIsOutOfRange
        };

        return returnValue;
    }

    function generateCalendarDatesListItems (data, calendarAttributes, maxItems, minimumNights) {
        var html = "";

        var itemsCount = 0;

        $.each(data, function () {
            if (itemsCount < maxItems) {

                var dateItemData = this;
                var newDates = handleOverflowedDates(dateItemData.from, dateItemData.to, calendarAttributes);
                if (!newDates.isOutOfRange) {

                    var nightsCount = getDaysCount(newDates.dateFrom.timestamp, newDates.dateTo.timestamp) - 1;
                    if (nightsCount >= minimumNights) {
                        var gtmLabel = global.removeDiacritics(dateItemData.text).toLowerCase().split(" ").join("-");
                        html = html + '<li><a href="" class="js-setCalendars js-gtm-eventClick" data-gtm-eventclick-category="click" data-gtm-eventclick-label="' + gtmLabel + '" data-gtm-eventclick-action="clickVybraneTerminy" data-nights-selector="closest(.grd-col)->find(.js-select-wrapper)" data-calendars-selector="closest(.grd-row)->find(.js-calendars)" data-calendar-selectedfrom="' + newDates.dateFrom.string + '" data-nights="' + dateItemData.nights + '" data-calendar-selectedto="' + newDates.dateTo.string + '">' + dateItemData.text + '</a></li>';
                        itemsCount = itemsCount + 1;
                    }

                }
            } else {
                return false;
            }


        });

        return html;
    }
    function generateCalendarDatesList () {
        var $placeholder = $(this);
        var dataVariableName = $placeholder.attr("data-variablename") || "calendarDatesList";

        if (dataVariableName in window && window[dataVariableName] && window[dataVariableName].length) {
            var data = window[dataVariableName];
            var $calendar = $placeholder.closest(".grd-row").find(".js-calendars").first();
            var attributes = getCalendarAttributes($calendar);

            var maxItems = $placeholder.attr("data-maxitems") || 8;
            var minimumNightsCount = $placeholder.attr("data-minimumnights") || 0;
            var itemsHtml = generateCalendarDatesListItems(data, attributes, maxItems, minimumNightsCount);

            if (itemsHtml) {
                var html = "<ul>" + itemsHtml + "</ul>";
                $placeholder.html(html);
            }
        }
    };




    $(document).on("initialize-calendars", function(e){
        $(this).find(".js-calendars").each(function () {
            var $calendar = $(this);
            createCalendars($calendar);
            //$calendar.find(".js-day").removeClass("calendar-item--selected calendar-item--handler");
        });
    });

    $(document).trigger("initialize-calendars");

    $(document).on("initialize-calendar-dates-list", function () {
        $(this).find(".js-calendarDatesList-placeholder").each(generateCalendarDatesList);
    });

    $(document).trigger("initialize-calendar-dates-list");

    $(document).on("mouseenter", ".fshr-calendar-tooltip", function () {
        var $tooltip = $(this);
        if ($tooltip.is(".qtip-pos-bc")) {
            $tooltip.removeClass("qtip-pos-bc").addClass("qtip-pos-tc");
        } else {
            $tooltip.removeClass("qtip-pos-tc").addClass("qtip-pos-bc");
        }
    });

    $(document).on("click", ".js-calendars-controls:not('.fshr-calendars-controls--disabled')", function (event) {
        event.preventDefault();
        var $control = $(this);
        var $calendarsPlaceholder = $control.closest(".js-calendars");
        var calendarAttributes = getCalendarAttributes($control);

        generateCalendars($calendarsPlaceholder, calendarAttributes, false);
    });

    $(document).on("update-highlighting", ".js-calendars", function () {
        var $calendar = $(this);
        var $firstDay = $calendar.find(".calendar-item:not(.calendar-item--disabled)").first();
        var dateFrom = $firstDay.attr("data-date").split("-");
        var dateFromMonth = dateFrom[1];
        var dateFromYear = dateFrom[0];
        var calendarAttributes = getCalendarAttributes($calendar);
        calendarAttributes.dateFromMonth = dateFromMonth;
        calendarAttributes.dateFromYear = dateFromYear;
        generateCalendars($calendar, calendarAttributes, false);
    });

    $(document).on("click", ".js-setCalendars", function (event) {
        event.preventDefault();
        var $trigger = $(this);
        var nightsCount = $trigger.attr("data-nights");
        var selectedFromDate = $trigger.attr("data-calendar-selectedfrom");
        var selectedToDate = $trigger.attr("data-calendar-selectedto");
        var calendarFrom = $trigger.attr("data-calendarfrom") || $trigger.attr("data-calendar-selectedfrom");
        var nightsElementSelector = $trigger.attr("data-nights-selector");
        var $nightsWrapper = global.getElementsBySelector(nightsElementSelector, $trigger);
        var $calendarsWrapper = global.getElementsBySelector($trigger.attr("data-calendars-selector"), $trigger);
        var zobrazPrechodoveTerminy = $trigger.attr("data-zobrazPrechodTerminy");



        if ($calendarsWrapper.length) {
            $calendarsWrapper.attr("data-calendarfrom", calendarFrom);
            var $inputs = getDateInputElements($calendarsWrapper);
            $inputs.dateFromElement.val(selectedFromDate);
            $inputs.dateToElement.val(selectedToDate);
            $inputs.dateFromElement.trigger("change");
            $inputs.dateToElement.trigger("change");
            var calendarAttributes = getCalendarAttributes($calendarsWrapper);
            generateCalendars($calendarsWrapper, calendarAttributes, false);
            //global.daysCountRestrictions($calendarsWrapper);
        }

        if ($nightsWrapper.length && nightsCount) {
            var isMultiple = $nightsWrapper.find("select").is("[multiple]");
            $nightsWrapper.find("option").prop("selected", false).removeAttr("selected");
            if (isMultiple) {
                var nightsCountArray = nightsCount.split(",");
                $nightsWrapper.find(".js-select-item input:checked").prop("checked", false);
                $.each(nightsCountArray, function () {
                    $nightsWrapper.find(".js-select-item[data-value='" + this + "'] input").prop("checked", true).trigger("change");
                });
            } else {
                $nightsWrapper.find(".js-select-item[data-value='" + nightsCount + "'] .js-select-handler").trigger("click");
            }
        }

        var $days = $calendarsWrapper.find(".js-day");
        disableFirstClick($calendarsWrapper, $days);

        var filterSelector = $trigger.attr("data-filter-selector");
        var $filter = $(filterSelector);
        if ($filter.length) {
            if(zobrazPrechodoveTerminy == "true"){
                var hiddeninput = $('<input type="hidden" name="zobrazPrechodoveTerminy" value="true">');
                $filter.append(hiddeninput);
                $filter.trigger("filter-changed-remotely");
                setTimeout(function(){hiddeninput.remove()},500);
            }else{
                $filter.trigger("filter-changed-remotely");    
            }
            
        }
    });

    $(document).on("regenerate-calendar", ".js-calendars", function () {
        var $calendar = $(this);
        var $inputs = getDateInputElements($calendar);
        var defaultData = getDefaultData($calendar);
        $inputs.dateFromElement.val(defaultData.from);
        $inputs.dateToElement.val(defaultData.to);
        createCalendars($calendar);
    });

    var setCalendarId = 0;
    $(document).on("set-calendar-byurl", ".js-calendars", function () {
        clearTimeout(setCalendarId);
        var $calendar = $(this);
        setCalendarId = setTimeout(function () {
            var $inputs = getDateInputElements($calendar);
            var attributes = getCalendarAttributes($calendar);
            attributes.selectedFrom = $inputs.dateFromElement.val();
            attributes.selectedTo = $inputs.dateToElement.val();

            attributes.dateFromMonth = attributes.selectedFrom.split("-")[1];
            attributes.dateFromYear = attributes.selectedFrom.split("-")[0];
            generateCalendars($calendar, attributes, true, true);
        });
    });

    function setCalendarDates () {
        var $filter = $(this);
        var $calendars = $filter.find(".js-calendars");
        if ($calendars.length) {
            $calendars.each(function () {
                var $calendar = $(this);
                var $inputs = getDateInputElements($calendar);
                if (!$inputs.dateFromElement.val() || !$inputs.dateToElement.val()) {
                    var $days = $calendar.find(".js-day");
                    var dateFrom = $inputs.dateFromElement.val() || $inputs.dateToElement.val();
                    var dateTo = createDateObjectFromString(dateFrom);
                    var attributes = getCalendarAttributes($calendar);
                    dateTo.setDate(dateTo.getDate() + attributes.defaultNightRange);
                    setDateFromAndDateTo(dateFrom, createDateStringFromObject(dateTo), $calendar, true);
                    disableFirstClick($calendar, $days);
                }
            });
        }
    }
    $(document).on("filter-beforeclose", ".js-filter", setCalendarDates);
    $(document).on("submit", "form.js-menuSearch-content", setCalendarDates);

})(jQuery, globalWrapper.fshr);
